/**
 * DeviceGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { DeviceData } from './device_data'

/**
 * DeviceGetRes
 */
export interface DeviceGetRes {
  /** 设备详情 */
  items?: DeviceData[]
}

/**
 * DeviceGetRes Schema
 */
export const DeviceGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '设备详情',
      format: '[]*model.DeviceData',
      items: { $ref: 'DeviceData', description: '' },
      type: 'array',
      label: '设备详情',
    },
  },
  type: 'object',
}
